<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout row justify-center>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" v-if="!enableReservation" @click="setEnableReservation">修改</v-btn>
          </v-card-title>
          <v-subheader v-if="ownerType==='group'">单位配置</v-subheader>
          <v-subheader v-if="ownerType==='object'">个人配置</v-subheader>
          <v-layout v-if="ownerType==='group'" class="mb-3">
            <v-flex xs4 class="pl-4">
            <v-autocomplete
              :disabled="(status!=='new')||(!enableReservation)"
              :items="searchSelects"
              v-model="ownerId"
              v-on:keyup="getSelection"
              label="分组名称"
              clearable
              hide-details
              hide-selected
              item-text="name"
              item-value="id"
              :rule="[$rules.requiredS('必填')]"
            >
              <template slot="no-data">
                <v-alert :value="true" color="error">
                  暂无该用户组信息
                </v-alert>
              </template>
              <template slot="item" slot-scope="props">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-flex row align-center justify-between>
                      <span>{{props.item.name}}</span>
                    </v-flex>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <span class="grey--text caption text-xs-right">{{props.item.code}}</span>
                </v-list-tile-action>
              </template>
            </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="ownerType==='object'" class="mb-3">
            <v-flex xs4 class="pl-4">
              <v-autocomplete
                :disabled="(status!=='new')||(!enableReservation)"
                :items="searchSelects"
                v-model="ownerId"
                v-on:keyup="getSelection"
                label="个人名称"
                clearable
                hide-details
                hide-selected
                item-text="name"
                item-value="id"
                :rule="[$rules.requiredS('必填')]"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 class="pl-4">
              <v-switch
                class="py-0"
                label="全局开关"
                persistent-hint
                :disabled="!enableReservation||readonly"
                v-model="isEnabled"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-container v-if="isEnabled">
          <v-form ref="form1">
            <v-layout v-if="enableReservation||readonly" column>
              <v-flex xs12>
                <l-select-controller
                  label-c="禁止预约通行关口"
                  label-p="禁止预约停车场区"
                  placeholder="没有配置"
                  :disabled="!enableReservation||readonly"
                  v-model="specificParkingLot"
                ></l-select-controller>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="机构最大预约上限" :prepend-icon="$vuetify.icons.location"
                              :disabled="!enableReservation||readonly" v-model="instMaxAppts" :rules="[$rules.requiredNum()]"></v-text-field>
              </v-flex>
              <v-flex xs6></v-flex>
            </v-layout>
          </v-form>
          <v-divider></v-divider>
          <v-form ref="form2">
            <template v-for="(c,key , i) in configs">
              <v-layout class="py-2" v-if="c.type === 'input'" row :key="key" align-center>
                <v-flex class="px-2" :key="'label' + i" xs8>
                        <span
                          class="subheading grey--text"
                        >{{c.label}}</span>
                </v-flex>
                <v-flex :key="'input' + i" xs2 offset-xs2>
                  <v-text-field
                    :disabled="!enableReservation||readonly"
                    hide-details
                    :rules="$rules.positiveInteger"
                    class="py-0 my-0"
                    v-model="c.value"
                    :type="c.inputType"
                    :suffix="c.suffix"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout :key="key" v-else-if="c.type==='switch'">
                <v-flex xs12>
                  <v-switch
                    class="py-0"
                    :label="c.label"
                    persistent-hint
                    :disabled="!enableReservation||readonly"
                    v-model="c.value"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout class="py-2" align-center :key="key" v-else-if="c.type==='select'">
                <v-flex class="px-2" xs7>
                        <span
                          class="subheading grey--text"
                        >{{c.label}}</span>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    class="py-0 mt-0"
                    hide-details
                    :items="c.items"
                    :disabled="!enableReservation||readonly"
                    v-model="c.value"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-subheader class="mt-4" :key="key" v-else-if="c.type==='header'">{{c.label}}</v-subheader>
            </template>
          </v-form>
          <v-divider></v-divider>
          <v-layout class="pb-3">
            <v-subheader>预约资源</v-subheader>
          </v-layout>
          <v-layout column>
            <div
              class="subheading grey--text pl-1"
            >园区关口组合选项
            </div>
            <v-list dense>
                <v-list-tile v-if="preControllers.length===0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              <v-list-group
              :key="i"
              v-for="(p,i) in preControllers">
                <template slot="activator">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{p.name}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="!readonly && enableReservation">
                      <v-menu left>
                        <v-btn slot="activator" icon small>
                          <v-icon small>$vuetify.icons.more</v-icon>
                        </v-btn>
                        <v-list dense>
                          <!-- @click="controllerDialog={activate: true,  status: 'edit',item: p.item,index:i}"-->
                          <v-list-tile
                            @click="editControllerConfig(p,i)"
                          >
                            <v-list-tile-title class="pr-1">
                              <v-flex layout align-center>
                                <span>修改配置</span>
                              </v-flex>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile
                            @click="deleteControllerConfig(i)"
                          >
                            <v-list-tile-title class="pr-1">
                              <v-flex layout align-center>
                                <span>删除配置</span>
                              </v-flex>
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
                <v-list-tile
                v-for="(subItem,index) in p.controllers"
                :key="index">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{subItem.name}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
            </v-list>
            <v-flex v-if="!readonly && enableReservation">
              <v-btn
                @click="controllerDialog={activate: true,  status: 'new'}"
                class="px-0"
                small
                flat
                color="primary"
              >添加配置
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout column v-if="orderType==='order_letter'||orderType==='order_group'">
            <div
              class="subheading grey--text pl-1"
            >单位单日可约次数上限
            </div>
            <v-list dense>
              <v-list-tile :key="i" v-for="(p,i) in groupMaxReservationPerDay">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="caption grey--text pr-3">停车场区</span>
                    <span class="body-1">{{p.parkingLot.name}}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <div>
                    <span class="caption grey--text pr-3">可预约次数</span>
                    <span class="body-1">{{p.times}}</span>
                  </div>
                </v-list-tile-action>
                <v-list-tile-action v-if="!readonly && enableReservation">
                  <v-menu left>
                    <v-btn slot="activator" icon small>
                      <v-icon small>$vuetify.icons.more</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile
                        @click="configDialog={activate: true,  status: 'edit',item: dealConfigPark(p), params: {type: 'group'}}"
                      >
                        <v-list-tile-title class="pr-1">
                          <v-flex layout align-center>
                            <span>修改配置</span>
                          </v-flex>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="deleteDialog = {activate: true, item: p, type: 'group'}"
                      >
                        <v-list-tile-title class="pr-1">
                          <v-flex layout align-center>
                            <span>删除配置</span>
                          </v-flex>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="groupMaxReservationPerDay.length === 0">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <div class="text-xs-center grey--text">没有配置</div>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-flex v-if="!readonly && enableReservation">
              <v-btn
                @click="configDialog={activate: true,  status: 'new', params: {type: 'group'}}"
                class="px-0"
                small
                flat
                color="primary"
              >添加配置
              </v-btn>
            </v-flex>
            <v-divider></v-divider>

            <!-- 中心区域限定性配置部分 - 内嵌形式，仅在单位预约场景显示，且不在单位配置详情页面显示 -->
            <v-layout column v-if="(orderType==='order_group' || orderType==='order_object') && !isConfigDetail">
              <div class="subheading grey--text pl-1" style="margin-top: 20px;margin-bottom: 20px;">中心区域限定性配置</div>
              <v-list dense>
                <v-list-tile v-if="areaLimitConfigs.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                
                <v-card class="mb-3" v-for="(config, index) in areaLimitConfigs" :key="key">
                  <v-card-title class="py-2 primary">
                    <span style="font-size: 16px;">{{config.name || '未命名配置'}}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="confirmDeleteAreaConfig(index)"
                          :disabled="!enableReservation || readonly">
                      <v-icon default>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="配置名称"
                          v-model="config.name"
                          :disabled="!enableReservation || readonly"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="单次预约时长(小时)"
                          type="number"
                          v-model="config.duration"
                          :rules="[$rules.positiveInteger]"
                          :disabled="!enableReservation || readonly"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          label="园区关口组合选项"
                          v-model="config.presetCtrlIds"
                          :items="preControllers"
                          item-text="name"
                          item-value="name"
                          multiple
                          clearable
                          chips
                          :disabled="!enableReservation || readonly"
                          @change="updateParkNameMultiple(config, $event)"
                          attach
                          ref="selectRef"
                          @blur="closeSelectMenu"
                        ></v-select>
                      </v-flex>
                      <!-- 显示选中的卡口列表 -->
                      <v-flex xs12 v-if="config.selectedControllers && config.selectedControllers.length > 0">
                        <div class="caption grey--text mb-1">包含卡口：</div>
                        <v-chip 
                          v-for="(controller, idx) in config.selectedControllers" 
                          :key="idx"
                          small
                          class="mr-1 mb-1"
                        >
                          {{ controller.name }}
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-list>
              <v-flex v-if="!readonly && enableReservation">
                <v-btn
                  @click="addAreaConfig"
                  class="px-0"
                  small
                  flat
                  color="primary"
                >
                  添加区域配置
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider v-if="orderType==='order_group'"></v-divider>
          </v-layout>
          <v-layout column v-if="orderType==='order_object'">
            <!-- 个人预约特殊配置部分 - 仅在个人预约场景显示，且不在配置详情页面显示 -->
            <v-layout column v-if="!isConfigDetail" style="margin-bottom: 20px;">
              <div class="subheading grey--text pl-1" style="margin-top: 20px;margin-bottom: 20px;">外围区域限定配置</div>
              <v-list dense>
                <v-list-tile v-if="personalConfigs.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                
                <v-card class="mb-3" v-for="(config, index) in personalConfigs" :key="`area-config-${index}`">
                  <v-card-title class="py-2 primary">
                    <span style="font-size: 16px;">{{config.name || '未命名配置'}}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="confirmDeletePersonalConfig(index)"
                          :disabled="!enableReservation || readonly">
                      <v-icon default>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="配置名称"
                          v-model="config.name"
                          :disabled="!enableReservation || readonly"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="单次预约时长(小时)"
                          type="number"
                          v-model="config.duration"
                          :rules="[$rules.positiveInteger]"
                          :disabled="!enableReservation || readonly"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          label="园区关口组合选项"
                          v-model="config.presetCtrlIds"
                          :items="preControllers"
                          item-text="name"
                          item-value="name"
                          multiple
                          clearable
                          chips
                          :disabled="!enableReservation || readonly"
                          attach
                          ref="selectRef"
                          @blur="closeSelectMenu"
                          @change="updateParkNameMultiplePersonal(config, $event)"
                        ></v-select>
                      </v-flex>
                      <!-- 显示选中的卡口列表 -->
                      <v-flex xs12 v-if="config.selectedControllers && config.selectedControllers.length > 0">
                        <div class="caption grey--text mb-1">包含卡口：</div>
                        <v-chip 
                          v-for="(controller, idx) in config.selectedControllers" 
                          :key="idx"
                          small
                          class="mr-1 mb-1"
                        >
                          {{ controller.name }}
                        </v-chip>
                      </v-flex>
                      <!-- 新增的两个多选框 -->
                      <v-flex xs12 sm6>
                        <v-select
                          label="管控园区"
                          v-model="config.restrictParkIds"
                          :items="restrictParkSelects"
                          item-text="name"
                          item-value="id"
                          multiple
                          clearable
                          chips
                          :disabled="!enableReservation || readonly"
                          attach
                          ref="selectRef"
                          @blur="closeSelectMenu"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                          label="管控类型"
                          v-model="config.orderTypes"
                          :items="orderTypeOptions"
                          item-text="text"
                          item-value="value"
                          item-disabled="disabled"
                          multiple
                          clearable
                          chips
                          :disabled="!enableReservation || readonly"
                          attach
                          ref="selectRef"
                          @blur="closeSelectMenu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-list>
              <v-flex v-if="!readonly && enableReservation">
                <v-btn
                  @click="addPersonalConfig"
                  class="px-0"
                  small
                  flat
                  color="primary"
                >
                  添加区域配置
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            
            <div
              class="subheading grey--text pl-1"
            >个人单日可约次数上限
            </div>
            <v-list dense>
              <v-list-tile :key="i" v-for="(p,i) in personMaxReservationPerDay">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="caption grey--text pr-3">停车场区</span>
                    <span class="body-1">{{p.parkingLot.name}}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <div>
                    <span class="caption grey--text pr-3">可预约次数</span>
                    <span class="body-1">{{p.times}}</span>
                  </div>
                </v-list-tile-action>
                <v-list-tile-action v-if="!readonly && enableReservation">
                  <v-btn icon small>
                    <v-menu left>
                      <v-btn slot="activator" icon small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile
                          @click="configDialog={activate: true,  status: 'edit',item: dealConfigPark(p), params: {type: 'person'}}"
                        >
                          <v-list-tile-title class="pr-1">
                            <v-flex layout align-center>
                              <span>修改配置</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          @click="deleteDialog = {activate: true, item: p, type: 'person'}"
                        >
                          <v-list-tile-title class="pr-1">
                            <v-flex layout align-center>
                              <span>删除配置</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="personMaxReservationPerDay.length === 0">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <div class="text-xs-center grey--text">没有配置</div>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-flex v-if="!readonly && enableReservation">
              <v-btn
                @click="configDialog={activate: true,  status: 'new', params: {type: 'person'}}"
                class="px-0"
                small
                flat
                color="primary"
              >添加配置
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-subheader>绑定模板</v-subheader>
          </v-layout>
          <v-form ref="form3">
            <v-layout :key="key" v-for="(t,key) in bindTemplates">
              <v-flex>
                <v-text-field
                  :clearable="enableReservation && !readonly"
                  @click="templateDialog={activate: true, item: t.value.id, type: t.templateType, for: key}"
                  :label="t.label"
                  v-model="t.value.name"
                  readonly
                  :disabled="!enableReservation || readonly"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          </v-container>
          <v-layout justify-center>
            <v-btn color="grey" @click="cancelConfig" v-if="enableReservation" class="white--text">取消</v-btn>
            <v-btn class="primary" @click="submitConfig" v-if="enableReservation">確定</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="templateDialog.activate" persistent max-width="500px">
      <l-select-template-dialog
        v-if="templateDialog.activate"
        :raw-item="templateDialog.item"
        :type="templateDialog.type"
        @cancel="templateDialog.activate = false"
        @save="bindTemplate($event, templateDialog.type, templateDialog.for)"
      ></l-select-template-dialog>
    </v-dialog>
    <l-confirm-delete-dialog
      item-text="配置"
      :item="deleteDialog.item"
      v-model="deleteDialog.activate"
      @delete="deleteConfig(deleteDialog.item, deleteDialog.type)"
      item-name="parkingLot.name"
    ></l-confirm-delete-dialog>
    <v-dialog v-model="configDialog.activate" max-width="500px" scrollable persistent>
      <parking-lot-config-content
        v-if="configDialog.activate"
        :raw-item="configDialog.item"
        :status="configDialog.status"
        :params="configDialog.params"
        @confirm="setConfig($event, configDialog.params.type)"
        @cancel="configDialog.activate = false"
      ></parking-lot-config-content>
    </v-dialog>
    <v-dialog v-model="controllerDialog.activate" max-width="600px" scrollable persistent>
      <pre-controllers-config
        v-if="controllerDialog.activate"
        :status="controllerDialog.status"
        :raw-item="controllerDialog.item"
        :raw-name="controllerDialog.name"
        @confirm="setControllerConfig($event)"
        @cancel="controllerDialog.activate = false"
      ></pre-controllers-config>
    </v-dialog>
  </l-layout>
</template>
<script>
import lSelectController from '../../../../components/LSelectController'
import parkingLotConfigContent from './parkingLotConfigContent'
import lConfirmDeleteDialog from '../../../../components/LConfirmDeleteDialog'
import lSelectTemplateDialog from '../../../../components/LSelectTemplateDialog'
import preControllersConfig from './preControllersConfig'
export default {
  name: 'commonConfig',
  components: {
    lSelectController,
    parkingLotConfigContent,
    lConfirmDeleteDialog,
    lSelectTemplateDialog,
    preControllersConfig
  },
  props: {
    orderTypeProp: {type: String, default: 'letterReservation'},
    statusProp: {type: String, default: 'edit'},
    ownerTypeProp: {type: String, default: 'common'},
    ownerIdProp: {type: String, default: ''},
    areaLimitConfigsProp: {
      type: Array,
      default: () => []
    },
    isConfigDetail: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      orderType: '',
      ownerType: '',
      status: '',
      enableReservation: false,
      readonly: false,
      specificParkingLot: [],
      preControllers: [],
      groupMaxReservationPerDay: [],
      personMaxReservationPerDay: [],
      ownerId: '',
      search: '',
      searchSelects: [],
      memberLoading: false,
      isEnabled: false,
      instMaxAppts:0,
      configs: {
        // personMaxAllowed: {label: '个人每天最多可预约车辆数', value: 0, type: 'input', inputType: 'number', suffix: '辆'},
        // groupMaxAllowed: {label: '单位每天最多可预约车辆数', value: 0, type: 'input', inputType: 'number', suffix: '辆'},
        infoConfig: {label: '访客信息', type: 'header'},
        isVnNeeded: {label: '是否登记来访人员姓名', value: false, type: 'switch'},
        isVoNeeded: {label: '是否登记来访人员单位', value: false, type: 'switch'},
        reservationTime: {label: '预约时间', type: 'header'},
        maxAEn: {label: '允许提前进场时间上限', value: 0, type: 'input', inputType: 'number', suffix: '分'},
        maxDEx: {label: '允许延期出场时间上限', value: 0, type: 'input', inputType: 'number', suffix: '分'},
        maxDurDays: {label: '允许预约持续时间上限', value: 0, type: 'input', inputType: 'number', suffix: '天'},
        maxAdvDays: {label: '允许提前预约天数上限', value: 0, type: 'input', inputType: 'number', suffix: '天'},
        reservationInfo: {label: '预约提醒', type: 'header'},
        msgSuccess: {
          label: '预约申请成功信息提示',
          value: '0',
          type: 'select',
          items: [
            {text: '不发送', value: '-1'},
            {text: '仅访客', value: '0'},
            {text: '仅受访人', value: '1'},
            {text: '访客和受访人', value: '2'},
          ]
        }, // -1 nether, 0 visitor, 1 beVisited(host), 2 both
        msgDExWarning: {
          label: '车辆延迟出场信息警示',
          value: '0',
          type: 'select',
          items: [
            {text: '不发送', value: '-1'},
            {text: '仅访客', value: '0'},
            {text: '仅受访人', value: '1'},
            {text: '访客和受访人', value: '2'},
          ]
        }, // -1 nether, 0 visitor, 1 beVisited(host), 2 both
        msgInOut: {label: '车辆入场出场信息提示', value: false, type: 'switch'},
        msgDExAlarm: {label: '车辆延迟出场信息告警', value: false, type: 'switch'},
      },
      bindTemplates: {
        'apptMsgSuccToVIM': {label: '预约申请成功-来访人-短信', value: {id: '', name: ''}, templateType: 'sms'},
        'apptMsgSuccToHWC': {label: '预约申请成功-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeInToHWC': {label: '预约车辆入场-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeOtToHWC': {label: '预约车辆出场-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeDoToHWC': {label: '延迟出场警示-来访人-短信', value: {id: '', name: ''}, templateType: 'sms'},
        'apptMsgVeDoToVIM': {label: '延迟出场警示-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeDoToAWC': {label: '延迟出场警示-管理员-微信', value: {id: '', name: ''}, templateType: 'wechat'}
      },
      controllerDialog: {
        activate: false,
        status: 'new',
        item: '',
        index: 0,
        name: ''
      },
      configDialog: {
        activate: false,
        item: {},
        params: {type: 'person'}
      },
      deleteDialog: {
        activate: false,
        item: {},
        type: 'group'
      },
      templateDialog: {
        activate: false,
        item: {},
        type: '__NONE__'
      },
      areaLimitConfigs: [],
      personalConfigs: [], // 个人外围区域限定配置
      globalLimitConfigs: [],
      // 管控类型选项
      orderTypeOptions: [
        {text: '个人预约', value: 'order_object', disabled: false},
        {text: '单位预约', value: 'order_group', disabled: true},
        {text: '自助预约', value: 'order_self', disabled: true},
        {text: '高级预约', value: 'admin', disabled: true},
        {text: '独立车辆', value: 'object', disabled: true},
        {text: '登记类型', value: 'group', disabled: true},
      ]
    }
  },
  created () {
    this.dealRouterParam()
    this.dealViewStatus()
    // 初始化区域限定配置
    this.initAreaLimitConfigs()
    // 初始化个人配置
    this.initPersonalConfigs()
    if (this.orderType === 'order_group' || this.orderType === 'order_object') {
      this.getGlobalLimitConfigs()
    }
  },
  activated () {

  },
  computed: {
    parkingLotSelects () {
      let selects = []
      if (this.items instanceof Array) {
        selects = this.items
      }
      else if (this.itemsP instanceof Array) {
        selects = this.itemsP
      }
      else if (this.$store.state.parkingLot.parkingLotList instanceof Array) {
        selects = this.$store.state.parkingLot.parkingLotList.slice()
      }
      if (selects.length === 0) {
        selects.push({header: '没有可选停车场区'})
      }
      return selects
    },
    // 新增：管控园区专用选项，只包含清水河校区和沙河校区
    restrictParkSelects () {
      const targetNames = ['清水河校区', '沙河校区']
      return this.parkingLotSelects.filter(park => 
        park.name && targetNames.includes(park.name)
      )
    },
    controllers () {
      let cs = []
      if (this.items instanceof Array) {
        cs = Array.prototype.concat.apply([], this.items.map(t => t.controllers))
      }
      else if (this.itemsC instanceof Array) {
        cs = this.itemsC
      }
      else if (this.$store.state.parkingLot.controllerList instanceof Array) {
        cs = this.$store.state.parkingLot.controllerList.slice()
      }
      return cs
    },
  },
  watch: {
    // 监听props中的areaLimitConfigs变化
    areaLimitConfigsProp: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.areaLimitConfigs = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true
    },
    // 监听内部areaLimitConfigs变化并通知父组件
    areaLimitConfigs: {
      handler(newVal) {
        this.$emit('update:areaLimitConfigs', newVal)
      },
      deep: true
    }
  },
  methods: {
    closeSelectMenu() {
      if (this.$refs.selectRef) {
        // 如果是数组，处理每个引用
        if (Array.isArray(this.$refs.selectRef)) {
          this.$refs.selectRef.forEach(ref => {
            if (ref && typeof ref.blur === 'function') {
              ref.blur()
            }
          })
        } 
        // 单个引用情况
        else if (typeof this.$refs.selectRef.blur === 'function') {
          this.$refs.selectRef.blur()
        }
      }
    },
    
    dealConfigPark(item){
      let arr1 = item.parkingLot.name.split(',')
      let arr2 = item.parkingLot.id.split(',')
      let res = []
      for(let i=0;i<arr1.length;i++){
        res.push({id:arr2[i],name:arr1[i]})
      }
      item.parkingLots = res
      //console.log(res)
      return item
    },
    editControllerConfig (data, index) {
      var item2 = []
      for (let i = 0; i < data.item.length; i++) {
        var obj = {
          name: data.item[i].name,
          id: data.item[i].id,
          controllers: data.item[i].controllers
        }
        item2.push(obj)
      }
      // console.log(item2)
      this.controllerDialog.activate = true
      this.controllerDialog.status = 'edit'
      this.controllerDialog.item = item2
      this.controllerDialog.index = index
      this.controllerDialog.name = data.name
    },
    dealRouterParam () {
      if (this.$route.query.orderType !== undefined) {
        this.orderType = this.$route.query.orderType
      }
      else {
        this.orderType = this.orderTypeProp
      }
      if (this.$route.query.status !== undefined) {
        this.status = this.$route.query.status
      }
      else {
        this.status = this.statusProp
      }
      if (this.$route.query.ownerType !== undefined) {
        this.ownerType = this.$route.query.ownerType
      }
      else {
        this.ownerType = this.ownerTypeProp
      }
      if (this.$route.query.ownerId !== undefined) {
        this.ownerId = this.$route.query.ownerId
      }
      else {
        this.ownerId = this.ownerIdProp
      }
    },
    dealViewStatus () {
      if (this.status === 'readonly') {
        this.readonly = true
        this.enableReservation = false
        if(this.$route.query.aim!==undefined&&this.$route.query.aim==='final'){
          this.getFinalConfig(this.$route.query.configType)
        }else{
          this.getConfig()
        }
      }
      else if (this.status === 'new') {
        this.readonly = false
        this.enableReservation = true
        if(this.$route.query.userId!==undefined){
          this.getConfigUser(this.$route.query.userId)
        }
      }
    },
    setEnableReservation () {
      this.enableReservation = true
      this.readonly = false
    },
    async getFinalConfig (type) {
      let res = await this.$store.dispatch('reservationConfig/getFinalConfig',{type:type,userId:this.$route.query.ownerId})
      if(res.data.status+''==='1'){
        this.dealConfigData(res.data.data)
      }
      if (this.ownerType === 'group') {
        this.getConfigGroup(this.ownerId)
      }
      else {
        this.getConfigUser(this.ownerId)
      }
    },
    async getConfig () {
      if (this.ownerType === 'common') {
        let param = 'vehicle_appt_global_config:' + this.orderType
        let res = await this.$store.dispatch('reservationConfig/getCommonConfig', param)
        if (res.data.status === 1) {
          this.dealConfigData(res.data.data)
        }
        else {
          this.$L.alert('error', {message: '查询配置信息失败，原因：' + res.data.msg})
        }
      }
      else {
        let res = await this.$store.dispatch('reservationConfig/getConfig', {orderType: this.orderType, ownerId: this.ownerId, ownerType: this.ownerType})
        if (res.data.status === 1) {
          console.log(res)
          let config = eval('(' + res.data.data.content[0].vehicle.ruleJson + ')')
          this.dealConfigData(config)
          if (this.ownerType === 'group') {
            this.getConfigGroup(res.data.data.content[0].group.id)
          }
          else {
            this.getConfigUser(res.data.data.content[0].user.id)
          }
        }
        else {
          this.$L.alert('error', {message: '查询配置信息失败，原因：' + res.data.msg})
        }
      }
    },
    async getConfigGroup (id) {
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'id': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroups', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.ownerId = res.data.data.content[0]
        this.searchSelects = []
        this.searchSelects.push(res.data.data.content[0])
        console.log(this.ownerId)
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async getConfigUser (id) {
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'id': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.ownerId = res.data.data.content[0]
        this.searchSelects = []
        this.searchSelects.push(res.data.data.content[0])
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    dealConfigData (data) {
      console.log('配置数据:', data)
      this.instMaxAppts = data.instMaxAppts
      this.isEnabled = data.isEnabled
      this.configs.isVnNeeded.value = data.isVnNeeded
      this.configs.isVoNeeded.value = data.isVoNeeded
      this.configs.maxAdvDays.value = data.maxAdvDays
      this.configs.maxAEn.value = data.maxAEn
      this.configs.maxDEx.value = data.maxDEx
      this.configs.maxDurDays.value = data.maxDurDays
      this.configs.msgSuccess.value = data.msgSuccess
      this.configs.msgDExAlarm.value = data.msgDExAlarm
      this.configs.msgDExWarning.value = data.msgDExWarning
      this.configs.msgInOut.value = data.msgInOut
      this.personMaxReservationPerDay = []
      this.groupMaxReservationPerDay = []
      for (let i = 0; i < data.maxAppts1p1d.length; i++) {
        let arr = data.maxAppts1p1d[i].parklotId.split(',')
        let obj = {
          times: data.maxAppts1p1d[i].times,
          parkingLot: {
            name:"",
            id: ""
          }
        }
        for(let j=0;j<arr.length;j++){
          for(let k=0;k<this.parkingLotSelects.length;k++){
            if(arr[j]===this.parkingLotSelects[k].id){
              if(j===arr.length-1){
                obj.parkingLot.name+=this.parkingLotSelects[k].name
                obj.parkingLot.id+=this.parkingLotSelects[k].id
              }else{
                obj.parkingLot.name+=this.parkingLotSelects[k].name+','
                obj.parkingLot.id+=this.parkingLotSelects[k].id+','
              }
            }
          }
        }
        this.personMaxReservationPerDay.push(obj)
      }
      for (let i = 0; i < data.maxAppts1o1d.length; i++) {
        let arr = data.maxAppts1o1d[i].parklotId.split(',')
        let obj1 = {
          times: data.maxAppts1o1d[i].times,
          parkingLot: {
            name:"",
            id: ""
          }
        }
        for(let j=0;j<arr.length;j++){
          for(let k=0;k<this.parkingLotSelects.length;k++){
            if(arr[j]===this.parkingLotSelects[k].id){
              if(j===arr.length-1){
                obj1.parkingLot.name+=this.parkingLotSelects[k].name
                obj1.parkingLot.id+=this.parkingLotSelects[k].id
              }else{
                obj1.parkingLot.name+=this.parkingLotSelects[k].name+','
                obj1.parkingLot.id+=this.parkingLotSelects[k].id+','
              }
            }
          }
        }
        this.groupMaxReservationPerDay.push(obj1)
      }
      this.dealBindTemplates(data.msgTmpl)
      this.dealDisabledControllers(data.isApptEnabled)
      this.dealPreControllers(data.presetCtrls)
      
      // 处理区域限定性配置 - 根据字段区分中心区域和个人外围区域
      this.areaLimitConfigs = []
      this.personalConfigs = []
      
      if (data.limitAreaConfigs && data.limitAreaConfigs.length > 0) {
        for (const config of data.limitAreaConfigs) {
          // 根据是否有restrictParkIds和orderTypes字段来判断是个人配置还是中心区域配置
          const isPersonalConfig = config.restrictParkIds || config.orderTypes
          
          // 查找与controllerIds匹配的预设控制器
          const presetCtrlIds = []
          let parkName = config.parkName || ''
          
          // 获取选中的卡口列表
          let selectedControllers = []
          
          // 如果有parkName，尝试找到对应的预设控制器
          if (parkName) {
            // 检查是否是多个预设控制器组合，先尝试逗号分隔
            let parkNames = parkName.split(',')
            if (parkNames.length === 1) {
              // 如果逗号分隔没有效果，尝试使用、分隔
              parkNames = parkName.split('、')
            }
            
            for (const name of parkNames) {
              const cleanName = name.trim()
              const selectedPreset = this.preControllers.find(p => p.name === cleanName)
              if (selectedPreset) {
                presetCtrlIds.push(cleanName)
                
                // 合并卡口列表
                if (selectedPreset.controllers) {
                  for (const controller of selectedPreset.controllers) {
                    if (!selectedControllers.some(c => c.id === controller.id)) {
                      selectedControllers.push(controller)
                    }
                  }
                }
              }
            }
          }
          
          // 如果没有找到预设控制器或无法从parkName获取，尝试通过controllerIds匹配
          if (presetCtrlIds.length === 0 && config.controllerIds && config.controllerIds.length > 0) {
            // 从controllerIds中获取卡口列表
            selectedControllers = config.controllerIds.map(id => {
              return this.controllers.find(c => c.id === id)
            }).filter(Boolean)
            
            // 尝试匹配预设控制器组合
            for (const presetCtrl of this.preControllers) {
              if (presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                // 检查预设控制器是否包含了部分controllerIds
                const presetCtrlIds = presetCtrl.controllers.map(c => c.id)
                const controllerIds = config.controllerIds
                const matches = presetCtrlIds.filter(id => controllerIds.includes(id))
                
                // 如果有匹配，添加到预设控制器列表
                if (matches.length > 0 && matches.length === presetCtrlIds.length) {
                  if (!parkName) {
                    parkName = presetCtrl.name
                  }
                  if (!presetCtrlIds.includes(presetCtrl.name)) {
                    presetCtrlIds.push(presetCtrl.name)
                  }
                }
              }
            }
            
            // 如果找到了预设控制器，更新parkName
            if (presetCtrlIds.length > 0 && !parkName) {
              parkName = presetCtrlIds.join('、')
            }
          }
          
          if (isPersonalConfig && this.orderType === 'order_object') {
            // 个人外围区域限定配置
            this.personalConfigs.push({
              name: config.name,
              duration: config.duration,
              presetCtrlIds: presetCtrlIds,
              parkName: parkName,
              selectedControllers: selectedControllers,
              gateIds: config.controllerIds || [],
              restrictParkIds: config.restrictParkIds || [],
              orderTypes: config.orderTypes || ['order_object']
            })
          } else if (!isPersonalConfig && this.orderType === 'order_group') {
            // 中心区域限定性配置
            this.areaLimitConfigs.push({
              name: config.name,
              duration: config.duration,
              presetCtrlIds: presetCtrlIds,
              parkName: parkName,
              selectedControllers: selectedControllers
            })
          }
        }
      }
      
      // 处理个人外围区域限定配置 (personalLimitConfigs)
      if (data.personalLimitConfigs && data.personalLimitConfigs.length > 0) {
        for (const config of data.personalLimitConfigs) {
          // 查找与gateIds匹配的预设控制器
          const presetCtrlIds = []
          let parkName = config.parkName || ''
          
          // 获取选中的卡口列表
          let selectedControllers = []
          
          // 如果有parkName，尝试找到对应的预设控制器
          if (parkName) {
            // 检查是否是多个预设控制器组合，先尝试逗号分隔
            let parkNames = parkName.split(',')
            if (parkNames.length === 1) {
              // 如果逗号分隔没有效果，尝试使用、分隔
              parkNames = parkName.split('、')
            }
            
            for (const name of parkNames) {
              const cleanName = name.trim()
              const selectedPreset = this.preControllers.find(p => p.name === cleanName)
              if (selectedPreset) {
                presetCtrlIds.push(cleanName)
                
                // 合并卡口列表
                if (selectedPreset.controllers) {
                  for (const controller of selectedPreset.controllers) {
                    if (!selectedControllers.some(c => c.id === controller.id)) {
                      selectedControllers.push(controller)
                    }
                  }
                }
              }
            }
          }
          
          // 如果没有找到预设控制器或无法从parkName获取，尝试通过gateIds匹配
          if (presetCtrlIds.length === 0 && config.gateIds && config.gateIds.length > 0) {
            // 从gateIds中获取卡口列表
            selectedControllers = config.gateIds.map(id => {
              return this.controllers.find(c => c.id === id)
            }).filter(Boolean)
            
            // 尝试匹配预设控制器组合
            for (const presetCtrl of this.preControllers) {
              if (presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                // 检查预设控制器是否包含了部分gateIds
                const presetCtrlIds = presetCtrl.controllers.map(c => c.id)
                const gateIds = config.gateIds
                const matches = presetCtrlIds.filter(id => gateIds.includes(id))
                
                // 如果有匹配，添加到预设控制器列表
                if (matches.length > 0 && matches.length === presetCtrlIds.length) {
                  if (!parkName) {
                    parkName = presetCtrl.name
                  }
                  if (!presetCtrlIds.includes(presetCtrl.name)) {
                    presetCtrlIds.push(presetCtrl.name)
                  }
                }
              }
            }
            
            // 如果找到了预设控制器，更新parkName
            if (presetCtrlIds.length > 0 && !parkName) {
              parkName = presetCtrlIds.join('、')
            }
          }
          
          // 添加到个人配置列表
          this.personalConfigs.push({
            name: config.name,
            duration: config.duration,
            presetCtrlIds: presetCtrlIds,
            parkName: parkName,
            selectedControllers: selectedControllers,
            gateIds: config.gateIds || [],
            restrictParkIds: config.restrictParkIds || [],
            orderTypes: config.orderTypes || ['order_object']
          })
        }
      }
      
      console.log('处理后的中心区域限定性配置:', this.areaLimitConfigs)
      console.log('处理后的个人外围区域限定配置:', this.personalConfigs)
    },
    dealBindTemplates (data) {
      for (let n in data) {
        this.bindTemplates[n].value.id = data[n].key
        this.bindTemplates[n].value.name = data[n].name
      }
    },
    dealDisabledControllers (data) {
      this.specificParkingLot = []
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.parkingLotSelects.length; j++) {
          if (data[i].parklotId === this.parkingLotSelects[j].id) {
            var obj = {
              name: this.parkingLotSelects[j].name,
              id: this.parkingLotSelects[j].id,
              controllers: []
            }
            for (let k = 0; k < data[i].isCtrlEnabled.length; k++) {
              for (let n = 0; n < this.controllers.length; n++) {
                if (data[i].isCtrlEnabled[k].controllerId === this.controllers[n].id) {
                  obj.controllers.push(this.controllers[n])
                }
              }
            }
            this.specificParkingLot.push(obj)
          }
        }
      }
    },
    dealPreControllers (data) {
      for (let k = 0; k < data.length; k++) {
        var name = data[k].name
        var controllers = []
        var items = []
        for (let i = 0; i < data[k].controllerIds.length; i++) {
          for (let j = 0; j < this.controllers.length; j++) {
            if (this.controllers[j].id === data[k].controllerIds[i]) {
              controllers.push(this.controllers[j])
            }
          }
        }
        for (let i = 0; i < this.parkingLotSelects.length; i++) {
          var item = {
            name: this.parkingLotSelects[i].name,
            id: this.parkingLotSelects[i].id,
            controllers: []
          }
          for (let j = 0; j < controllers.length; j++) {
            if (controllers[j].parkingLot.id === this.parkingLotSelects[i].id) {
              item.controllers.push(controllers[j])
            }
          }
          if (item.controllers.length !== 0) {
            items.push(item)
          }
        }
        var config = {
          name: name,
          controllers: controllers,
          item: items
        }
        this.preControllers.push(config)
      }
    },
    checkConfigValid () {
      return this.$refs.form1.validate() && this.$refs.form2.validate() && this.$refs.form3.validate()
    },
    cancelConfig () {
      this.enableReservation = false
    },
    async submitConfig () {
      console.log(this.bindTemplates)
      let maxAppts1o1d = []
      let maxAppts1p1d = []
      let presetCtrls = []
      let isApptEnabled = []
      for (let i = 0; i < this.groupMaxReservationPerDay.length; i++) {
        var obj = {
          'parklotId': this.groupMaxReservationPerDay[i].parkingLot.id,
          'times': this.groupMaxReservationPerDay[i].times
        }
        maxAppts1o1d.push(obj)
      }
      for (let i = 0; i < this.personMaxReservationPerDay.length; i++) {
        var obj = {
          'parklotId': this.personMaxReservationPerDay[i].parkingLot.id,
          'times': this.personMaxReservationPerDay[i].times
        }
        maxAppts1p1d.push(obj)
      }
      for (let i = 0; i < this.preControllers.length; i++) {
        var obj = {
          'name': this.preControllers[i].name,
          'controllerIds': []
        }
        for (let j = 0; j < this.preControllers[i].controllers.length; j++) {
          obj['controllerIds'].push(this.preControllers[i].controllers[j].id)
        }
        presetCtrls.push(obj)
      }
      // console.log(this.specificParkingLot)
      for (let i = 0; i < this.specificParkingLot.length; i++) {
        var obj = {
          parklotId: this.specificParkingLot[i].id,
          isEnabled: false,
          isCtrlEnabled: []
        }
        for (let j = 0; j < this.specificParkingLot[i].controllers.length; j++) {
          let item = {
            controllerId: this.specificParkingLot[i].controllers[j].id,
            isEnabled: false
          }
          obj.isCtrlEnabled.push(item)
        }
        isApptEnabled.push(obj)
      }
      // console.log(isApptEnabled)
      let configJson = {
        'isApptEnabled': isApptEnabled,
        'isEnabled': this.isEnabled,
        'isVnNeeded': this.configs.isVnNeeded.value,
        'isVoNeeded': this.configs.isVoNeeded.value,
        'maxAEn': this.configs.maxAEn.value,
        'maxAdvDays': this.configs.maxAdvDays.value,
        'presetCtrls': presetCtrls,
        'maxAppts1o1d': maxAppts1o1d,
        'maxAppts1p1d': maxAppts1p1d,
        "instMaxAppts":this.instMaxAppts,
        'maxDEx': this.configs.maxDEx.value,
        'maxDurDays': this.configs.maxDurDays.value,
        'msgDExAlarm': this.configs.msgDExAlarm.value,
        'msgDExWarning': this.configs.msgDExWarning.value,
        'msgInOut': this.configs.msgInOut.value,
        'msgSuccess': this.configs.msgSuccess.value,
        'msgTmpl': {
          'apptMsgSuccToHWC': {
            'key': this.bindTemplates.apptMsgSuccToHWC.value.id,
            'name': this.bindTemplates.apptMsgSuccToHWC.value.name
          },
          'apptMsgSuccToVIM': {
            'key': this.bindTemplates.apptMsgSuccToVIM.value.id,
            'name': this.bindTemplates.apptMsgSuccToVIM.value.name
          },
          'apptMsgVeDoToAWC': {
            'key': this.bindTemplates.apptMsgVeDoToAWC.value.id,
            'name': this.bindTemplates.apptMsgVeDoToAWC.value.name
          },
          'apptMsgVeDoToHWC': {
            'key': this.bindTemplates.apptMsgVeDoToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeDoToHWC.value.name
          },
          'apptMsgVeDoToVIM': {
            'key': this.bindTemplates.apptMsgVeDoToVIM.value.id,
            'name': this.bindTemplates.apptMsgVeDoToVIM.value.name
          },
          'apptMsgVeInToHWC': {
            'key': this.bindTemplates.apptMsgVeInToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeInToHWC.value.name
          },
          'apptMsgVeOtToHWC': {
            'key': this.bindTemplates.apptMsgVeOtToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeOtToHWC.value.name
          }
        }
      }
      
      // 处理区域限定配置 - 确保总是包含limitAreaConfigs字段
      let limitAreaConfigs = []
      
      // 处理中心区域限定性配置
      for (let i = 0; i < this.areaLimitConfigs.length; i++) {
        const config = this.areaLimitConfigs[i]
        
        // 从选中的卡口列表或从预设控制器中获取关口ID
        let controllerIds = []
        
        // 先使用已经计算好的selectedControllers
        if (config.selectedControllers && config.selectedControllers.length > 0) {
          controllerIds = config.selectedControllers.map(c => c.id)
        }
        // 如果没有selectedControllers，则从presetCtrlIds中获取
        else if (config.presetCtrlIds && config.presetCtrlIds.length > 0) {
          for (const presetCtrlId of config.presetCtrlIds) {
            const presetCtrl = this.preControllers.find(p => p.name === presetCtrlId)
            if (presetCtrl && presetCtrl.controllers && presetCtrl.controllers.length > 0) {
              // 合并卡口ID，避免重复
              for (const controller of presetCtrl.controllers) {
                if (!controllerIds.includes(controller.id)) {
                  controllerIds.push(controller.id)
                }
              }
            }
          }
        }
        
        // 只有名称和预设控制器ID不为空时才添加配置
        if (config.name && controllerIds.length > 0) {
          limitAreaConfigs.push({
            name: config.name,
            parkName: config.parkName,
            duration: parseInt(config.duration),
            controllerIds: controllerIds
          })
        }
      }
      
      // 处理个人外围区域限定配置，合并到limitAreaConfigs中
      if (this.orderType === 'order_object') {
        for (let i = 0; i < this.personalConfigs.length; i++) {
          const config = this.personalConfigs[i]
          
          // 从选中的卡口列表或从预设控制器中获取关口ID
          let controllerIds = []
          
          // 先使用已经计算好的selectedControllers
          if (config.selectedControllers && config.selectedControllers.length > 0) {
            controllerIds = config.selectedControllers.map(c => c.id)
          }
          // 如果没有selectedControllers，则从presetCtrlIds中获取
          else if (config.presetCtrlIds && config.presetCtrlIds.length > 0) {
            for (const presetCtrlId of config.presetCtrlIds) {
              const presetCtrl = this.preControllers.find(p => p.name === presetCtrlId)
              if (presetCtrl && presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                // 合并卡口ID，避免重复
                for (const controller of presetCtrl.controllers) {
                  if (!controllerIds.includes(controller.id)) {
                    controllerIds.push(controller.id)
                  }
                }
              }
            }
          }
          
          // 只有名称和关口ID不为空时才添加配置
          if (config.name && (controllerIds.length > 0 || (config.restrictParkIds && config.restrictParkIds.length > 0))) {
            limitAreaConfigs.push({
              name: config.name,
              parkName: config.parkName,
              duration: parseInt(config.duration),
              controllerIds: controllerIds,
              // 个人配置特有的字段
              restrictParkIds: config.restrictParkIds || [],
              orderTypes: config.orderTypes || ['order_object']
            })
          }
        }
      }
      
      // 总是设置limitAreaConfigs字段，包含中心区域和个人外围区域配置
      configJson.limitAreaConfigs = limitAreaConfigs
      if (this.ownerType === 'common') {
        let res = await this.$store.dispatch('reservationConfig/submitConfig', {config: configJson, type: this.orderType})
        if (res.data.status === 1) {
          this.enableReservation = false
          if (this.status === 'new') {
            this.$L.alert('success', {message: '创建成功'})
          }
          else {
            this.$L.alert('success', {message: '修改成功'})
          }
        }
        else {
          this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
        }
      }
      else {
        let orderConfig = {
          'ownerId': (this.ownerId.id === undefined) ? this.ownerId : this.ownerId.id,
          'ownerType': this.ownerType,
          'orderType': this.orderType
        }
        let param = {
          'orderConfig': orderConfig,
          'config': configJson
        }
        let res = await this.$store.dispatch('reservationConfig/putConfig', param)
        if (res.data.status === 1) {
          this.enableReservation = false
          if (this.status === 'new') {
            this.$L.alert('success', {message: '创建成功'})
          }
          else {
            this.$L.alert('success', {message: '修改成功'})
          }
        }
        else {
          this.$L.alert('error', {message: res.data.msg})
        }
      }
    },
    bindTemplate (t, type, key) {
      // console.log('bind template', t, type, key)
      this.bindTemplates[key].value.id = t.id
      this.bindTemplates[key].value.name = t.name
      this.templateDialog.activate = false
    },
    deleteConfig (v, type) {
      if (!v) {
        this.deleteDialog.activate = false
        return
      }
      if (type === 'group') {
        let i = this.groupMaxReservationPerDay.indexOf(v)
        if (i >= 0) {
          this.groupMaxReservationPerDay.splice(i, 1)
        }
      }
      if (type === 'person') {
        let i = this.personMaxReservationPerDay.indexOf(v)
        if (i >= 0) {
          this.personMaxReservationPerDay.splice(i, 1)
        }
      }
      this.deleteDialog.activate = false
    },
    setConfig (c, type) {
      // console.log(c)
      let {newItem, oldItem, status} = c
      if (type === 'group') {
        if (status === 'new') {
          for(let i=0;i<this.groupMaxReservationPerDay.length;i++){
            if(this.groupMaxReservationPerDay[i].parkingLot.id===c.newItem.parkingLot.id){
              return
            }
          }
          this.groupMaxReservationPerDay.push(c.newItem)
        }
        else {
          let i = this.groupMaxReservationPerDay.indexOf(oldItem)
          // console.log('index', i, this.groupMaxReservationPerDay, oldItem)
          if (i >= 0) {
            this.groupMaxReservationPerDay.splice(i, 1, newItem)
          }
        }
      }
      if (type === 'person') {
        if (status === 'new') {
          for(let i=0;i<this.personMaxReservationPerDay.length;i++){
            if(this.personMaxReservationPerDay[i].parkingLot.id === c.newItem.parkingLot.id){
              this.$L.alert("error",{message:"已有相同园区配置"})
              return
            }
          }
          this.personMaxReservationPerDay.push(c.newItem)
        }
        else {
          let i = this.personMaxReservationPerDay.indexOf(oldItem)
          if (i >= 0) {
            this.personMaxReservationPerDay.splice(i, 1, newItem)
          }
        }
      }
      this.configDialog.activate = false
    },
    setControllerConfig (c) {
      let {newItem, oldItem, status, name} = c
      if (status === 'new') {
        let config = {
          name: name,
          controllers: [],
          item: newItem
        }
        for (let i = 0; i < newItem.length; i++) {
          for (let j = 0; j < newItem[i].controllers.length; j++) {
            config.controllers.push(newItem[i].controllers[j])
          }
        }
        this.preControllers.push(config)
      }
      else {
        let config = this.preControllers[this.controllerDialog.index]
        config.item = newItem
        config.name = name
        config.controllers = []
        for (let i = 0; i < newItem.length; i++) {
          for (let j = 0; j < newItem[i].controllers.length; j++) {
            config.controllers.push(newItem[i].controllers[j])
          }
        }
        this.preControllers.splice(this.controllerDialog.index, 1, config)
      }
      console.log(this.preControllers)
      this.controllerDialog.activate = false
    },
    async deleteControllerConfig (index) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该配置？'})
      if (res) {
        this.preControllers.splice(index, 1)
      }
      close()
    },
    async getSelection (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      if (this.ownerType === 'group') {
        let param = {
          'searchParam': {
            'name': {
              'index': '1',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': search,
                  'operator': 'LIKE',
                  'matchType': 'BOTH'
                }
              ]
            }
          }
        }
        let res = await this.$store.dispatch('reservationConfig/getGroups', {param: param, pagination: pagination})
        if (res.data.status === 1) {
          this.searchSelects = res.data.data.content
        }
        else {
          this.searchSelects = []
        }
      }
      else if (this.ownerType === 'object') {
        let param = {
          'searchParam': {
            'name': {
              'index': '1',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': search,
                  'operator': 'LIKE',
                  'matchType': 'BOTH'
                }
              ]
            }
          }
        }
        let res = await this.$store.dispatch('reservationConfig/getUsers', {param: param, pagination: pagination})
        if (res.data.status === 1) {
          this.searchSelects = res.data.data.content
        }
        else {
          this.searchSelects = []
        }
      }
    },
    addAreaConfig() {
      this.areaLimitConfigs.push({
        name: '',
        duration: 2,
        presetCtrlIds: [], // 改为数组，支持多选
        parkName: '',
        selectedControllers: [] // 添加选中的卡口列表
      })
    },
    updateParkNameMultiple(config, values) {
      // 如果没有选择，清空数据
      if (!values || values.length === 0) {
        config.parkName = ''
        config.selectedControllers = []
        return
      }
      
      // 更新区域配置的parkName，使用第一个选中的值或多个值的组合
      if (values.length === 1) {
        config.parkName = values[0]
      } else {
        config.parkName = values.join('、')
      }
      
      // 更新选中的卡口列表，合并所有选中的预设控制器的卡口
      config.selectedControllers = []
      
      // 遍历所有选中的预设控制器
      for (const presetCtrlName of values) {
        const selectedPreset = this.preControllers.find(p => p.name === presetCtrlName)
        if (selectedPreset && selectedPreset.controllers) {
          // 合并卡口，避免重复
          for (const controller of selectedPreset.controllers) {
            if (!config.selectedControllers.some(c => c.id === controller.id)) {
              config.selectedControllers.push(controller)
            }
          }
        }
      }
      
      console.log('更新后的配置:', config.name, '预设控制器:', values, '选中卡口数量:', config.selectedControllers.length)
    },
    async confirmDeleteAreaConfig(index) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该区域配置？'})
      if (res) {
        this.removeAreaConfig(index)
      }
      close()
    },
    removeAreaConfig(index) {
      this.areaLimitConfigs.splice(index, 1)
    },
    async getGlobalLimitConfigs() {
      try {
        // 使用已有的 getCommonConfig action 获取全局配置
        let param = 'vehicle_appt_global_config:' + this.orderType
        const res = await this.$store.dispatch('reservationConfig/getCommonConfig', param)
        
        console.log('获取全局限定性配置响应:', res.data)
        
        if (res.data && res.data.status === 1) {
          // 处理接口返回的数据
          const configData = res.data.data
          
          if (configData && configData.limitAreaConfigs && configData.limitAreaConfigs.length > 0) {
            console.log('获取到全局限定性配置:', configData.limitAreaConfigs)
            this.globalLimitConfigs = configData.limitAreaConfigs
            
            // 如果是新建状态且没有已有配置，使用全局配置
            if (this.status === 'new' && this.areaLimitConfigs.length === 0) {
              this.mergeGlobalLimitConfigs()
            }
          } else {
            console.log('全局限定性配置为空')
          }
        } else {
          console.error('获取全局限定性配置失败:', res.data && res.data.msg)
        }
      } catch (error) {
        console.error('获取全局限定性配置出错:', error)
      }
    },
    mergeGlobalLimitConfigs() {
      if (this.globalLimitConfigs.length > 0) {
        // 使用全局配置替换当前配置
        this.areaLimitConfigs = this.globalLimitConfigs.map(config => {
          // 查找匹配的预设控制器
          let presetCtrlId = ''
          
          // 如果有parkName字段，直接使用
          if (config.parkName) {
            presetCtrlId = config.parkName
          }
          // 否则尝试通过controllerIds匹配预设控制器
          else if (config.controllerIds && config.controllerIds.length > 0) {
            // 尝试匹配预设控制器组合
            const controllerIdsSet = new Set(config.controllerIds)
            for (const presetCtrl of this.preControllers) {
              if (presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                const presetCtrlIds = presetCtrl.controllers.map(c => c.id)
                // 检查是否完全匹配
                if (presetCtrlIds.length === config.controllerIds.length && 
                    presetCtrlIds.every(id => controllerIdsSet.has(id))) {
                  presetCtrlId = presetCtrl.name
                  // 使用预设控制器的卡口列表
                  selectedControllers = [...presetCtrl.controllers]
                  break
                }
              }
            }
          }
          
          return {
            name: config.name,
            duration: config.duration,
            presetCtrlId: presetCtrlId,
            parkName: config.parkName || presetCtrlId
          }
        })
      }
    },
    // 初始化区域限定配置
    initAreaLimitConfigs() {
      if (this.areaLimitConfigsProp && this.areaLimitConfigsProp.length > 0) {
        // 如果父组件传入了配置，使用父组件的配置并转换为合适的格式
        this.areaLimitConfigs = this.areaLimitConfigsProp.map(config => {
          // 查找匹配的预设控制器
          const presetCtrlIds = []
          let parkName = config.parkName || ''
          
          // 如果有parkName，尝试找到对应的预设控制器
          if (parkName) {
            // 检查是否是多个预设控制器组合
            const parkNames = parkName.split('、')
            
            for (const name of parkNames) {
              const selectedPreset = this.preControllers.find(p => p.name === name)
              if (selectedPreset) {
                presetCtrlIds.push(name)
              }
            }
          }
          
          // 获取选中的卡口列表
          let selectedControllers = []
          
          // 优先从presetCtrlIds获取卡口列表
          if (presetCtrlIds.length > 0) {
            for (const presetCtrlId of presetCtrlIds) {
              const selectedPreset = this.preControllers.find(p => p.name === presetCtrlId)
              if (selectedPreset && selectedPreset.controllers) {
                // 合并卡口列表
                for (const controller of selectedPreset.controllers) {
                  if (!selectedControllers.some(c => c.id === controller.id)) {
                    selectedControllers.push(controller)
                  }
                }
              }
            }
          } 
          // 如果没有presetCtrlIds，尝试从controllerIds或gates获取
          else if (config.controllerIds || config.gates) {
            // 从controllerIds或gates中获取卡口列表
            const ids = config.controllerIds || config.gates || []
            selectedControllers = ids.map(id => {
              return this.controllers.find(c => c.id === id)
            }).filter(Boolean)
            
            // 尝试匹配预设控制器
            for (const presetCtrl of this.preControllers) {
              if (presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                // 检查预设控制器是否包含了部分controllerIds
                const presetCtrlIds = presetCtrl.controllers.map(c => c.id)
                const controllerIds = ids
                const matches = presetCtrlIds.filter(id => controllerIds.includes(id))
                
                // 如果有匹配，添加到预设控制器列表
                if (matches.length > 0 && matches.length === presetCtrlIds.length) {
                  if (!parkName) {
                    parkName = presetCtrl.name
                  }
                  if (!presetCtrlIds.includes(presetCtrl.name)) {
                    presetCtrlIds.push(presetCtrl.name)
                  }
                }
              }
            }
            
            // 如果找到了预设控制器，更新parkName
            if (presetCtrlIds.length > 0 && !parkName) {
              parkName = presetCtrlIds.join('、')
            }
          }
          
          return {
            name: config.name,
            duration: config.duration,
            presetCtrlIds: presetCtrlIds,
            parkName: parkName,
            selectedControllers: selectedControllers
          }
        })
      } 
    },
    // 初始化个人配置
    initPersonalConfigs() {
      if (this.areaLimitConfigsProp && this.areaLimitConfigsProp.length > 0) {
        // 如果父组件传入了配置，使用父组件的配置并转换为合适的格式
        this.personalConfigs = this.areaLimitConfigsProp.map(config => {
          // 查找匹配的预设控制器
          const presetCtrlIds = []
          let parkName = config.parkName || ''
          
          // 如果有parkName，尝试找到对应的预设控制器
          if (parkName) {
            // 检查是否是多个预设控制器组合
            const parkNames = parkName.split('、')
            
            for (const name of parkNames) {
              const selectedPreset = this.preControllers.find(p => p.name === name)
              if (selectedPreset) {
                presetCtrlIds.push(name)
              }
            }
          }
          
          // 获取选中的卡口列表
          let selectedControllers = []
          
          // 优先从presetCtrlIds获取卡口列表
          if (presetCtrlIds.length > 0) {
            for (const presetCtrlId of presetCtrlIds) {
              const selectedPreset = this.preControllers.find(p => p.name === presetCtrlId)
              if (selectedPreset && selectedPreset.controllers) {
                // 合并卡口列表
                for (const controller of selectedPreset.controllers) {
                  if (!selectedControllers.some(c => c.id === controller.id)) {
                    selectedControllers.push(controller)
                  }
                }
              }
            }
          } 
          // 如果没有presetCtrlIds，尝试从controllerIds或gates获取
          else if (config.controllerIds || config.gates) {
            // 从controllerIds或gates中获取卡口列表
            const ids = config.controllerIds || config.gates || []
            selectedControllers = ids.map(id => {
              return this.controllers.find(c => c.id === id)
            }).filter(Boolean)
            
            // 尝试匹配预设控制器
            for (const presetCtrl of this.preControllers) {
              if (presetCtrl.controllers && presetCtrl.controllers.length > 0) {
                // 检查预设控制器是否包含了部分controllerIds
                const presetCtrlIds = presetCtrl.controllers.map(c => c.id)
                const controllerIds = ids
                const matches = presetCtrlIds.filter(id => controllerIds.includes(id))
                
                // 如果有匹配，添加到预设控制器列表
                if (matches.length > 0 && matches.length === presetCtrlIds.length) {
                  if (!parkName) {
                    parkName = presetCtrl.name
                  }
                  if (!presetCtrlIds.includes(presetCtrl.name)) {
                    presetCtrlIds.push(presetCtrl.name)
                  }
                }
              }
            }
            
            // 如果找到了预设控制器，更新parkName
            if (presetCtrlIds.length > 0 && !parkName) {
              parkName = presetCtrlIds.join('、')
            }
          }
          
          // 获取清水河校区和沙河校区的实际id作为默认值
          let defaultParkIds = []
          if (this.restrictParkSelects && this.restrictParkSelects.length > 0) {
            defaultParkIds = this.restrictParkSelects.map(park => park.id)
          }
          
          return {
            name: config.name,
            duration: config.duration,
            presetCtrlIds: presetCtrlIds,
            parkName: parkName,
            selectedControllers: selectedControllers,
            gateIds: config.controllerIds || config.gates || [],
            restrictParkIds: config.restrictParkIds || defaultParkIds,
            orderTypes: config.orderTypes || ['order_object']
          }
        })
      }
    },
    // 添加获取控制器名称的方法
    getControllerName(controllerId) {
      if (typeof controllerId === 'object' && controllerId.name) {
        return controllerId.name
      }
      
      const controller = this.controllers.find(c => c.id === controllerId)
      return controller ? controller.name : controllerId
    },
    
    // 移除关口
    removeGate(config, gate) {
      const gateId = typeof gate === 'object' ? gate.id : gate
      const index = config.gates.findIndex(g => {
        return (typeof g === 'object' ? g.id : g) === gateId
      })
      if (index !== -1) {
        config.gates.splice(index, 1)
      }
    },
    
     // v-select 会自动在失去焦点时关闭下拉菜单，无需手动处理
              
    // 个人配置相关方法
    addPersonalConfig() {
      // 获取清水河校区和沙河校区的实际id
      let defaultParkIds = []
      
      // 确保restrictParkSelects有数据
      if (this.restrictParkSelects && this.restrictParkSelects.length > 0) {
        defaultParkIds = this.restrictParkSelects.map(park => park.id)
      }
      
      this.personalConfigs.push({
        name: '',
        duration: null,
        presetCtrlIds: [],
        parkName: '',
        selectedControllers: [],
        gateIds: [], // 对应API中的gateIds
        restrictParkIds: defaultParkIds, // 管控园区，默认选中清水河校区和沙河校区
        orderTypes: ['order_object'] // 管控类型，默认选中个人预约
      })
    },
    async confirmDeletePersonalConfig(index) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该区域配置？'})
      if (res) {
        this.removePersonalConfig(index)
      }
      close()
    },
    removePersonalConfig(index) {
      this.personalConfigs.splice(index, 1)
    },
    
    // 个人配置中更新园区关口组合选项
    updateParkNameMultiplePersonal(config, values) {
      // 如果没有选择，清空数据
      if (!values || values.length === 0) {
        config.parkName = ''
        config.selectedControllers = []
        config.gateIds = []
        return
      }
      
      // 更新个人配置的parkName，使用第一个选中的值或多个值的组合
      if (values.length === 1) {
        config.parkName = values[0]
      } else {
        config.parkName = values.join('、')
      }
      
      // 更新选中的卡口列表，合并所有选中的预设控制器的卡口
      config.selectedControllers = []
      config.gateIds = []
      
      // 遍历所有选中的预设控制器
      for (const presetCtrlName of values) {
        const selectedPreset = this.preControllers.find(p => p.name === presetCtrlName)
        if (selectedPreset && selectedPreset.controllers) {
          // 合并卡口，避免重复
          for (const controller of selectedPreset.controllers) {
            if (!config.selectedControllers.some(c => c.id === controller.id)) {
              config.selectedControllers.push(controller)
              config.gateIds.push(controller.id) // 同时更新gateIds
            }
          }
        }
      }
      
    },
    
  },
}
</script>
